import { withStyles } from '@material-ui/core/styles';
import { SERVICE_LIST_TITLE } from '../../libraries/texts';
import ServiceService from '../../services/service-service';

import ListForm from '../maintainer/list';
import { MaintainerList as styles } from '../maintainer/styles';

export default withStyles(styles)(
  ListForm({ service: ServiceService, title: SERVICE_LIST_TITLE, name: 'SERVICE' })
);
